var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9051 17.5005C34.9051 27.1146 27.1115 34.9084 17.4975 34.9084C7.88341 34.9084 0.0897217 27.1146 0.0897217 17.5005C0.0897217 7.88646 7.88341 0.0927734 17.4975 0.0927734C27.1114 0.0927734 34.9051 7.88646 34.9051 17.5005Z",
    fill: "#00A478"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7124 17.1953V14.1499H11.5819V11.4805H23.1242V14.1875H18.9937V17.1953H15.7124Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80615 17.5337C9.80615 16.5186 13.126 15.6914 17.2565 15.6914C21.387 15.6914 24.7069 16.5186 24.7069 17.5337C24.7069 18.5488 21.387 19.376 17.2565 19.376C13.126 19.376 9.80615 18.5488 9.80615 17.5337ZM24.0892 17.5337C23.819 17.1577 21.58 15.9922 17.2565 15.9922C12.933 15.9922 10.694 17.1201 10.4238 17.5337C10.694 17.9097 12.933 18.4736 17.2565 18.4736C21.6187 18.4736 23.819 17.9097 24.0892 17.5337Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9936 18.1353V16.0298C18.4532 15.9922 17.8741 15.9546 17.2951 15.9546C16.7547 15.9546 16.2528 15.9546 15.751 15.9922V18.0977C16.2142 18.0977 16.7547 18.1353 17.2951 18.1353C17.8741 18.1729 18.4532 18.1729 18.9936 18.1353Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2565 19.376C16.7161 19.376 16.2142 19.376 15.7124 19.3384V24.9404H18.955V19.3008C18.4146 19.3384 17.8356 19.376 17.2565 19.376Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.5d17448e96385909ab15c984c3d2aed0.svg";
export { ForwardRef as ReactComponent };